import React from 'react';
import PropTypes from 'prop-types';
import { stringReplace } from 'utils';
import classNames from 'classnames';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/SpectrumResultColumns.scss';

const SpectrumResultColumns = ({ columns, columnValues, answeredIndex = 0 }) => {

  const getBgImagePart = (colValue, index) => {
    const RGB_POSITIVE = [120, 226, 120]; // $brand-success-light
    const RGB_NEUTRAL = [170, 170, 170]; // $brand-grayscale-7
    const RGB_NEGATIVE = [255, 131, 131]; // $brand-danger-light
    const rgb = colValue === 0 ? RGB_NEUTRAL : (colValue > 0 ? RGB_POSITIVE : RGB_NEGATIVE);
    const opacity = (0.9 * Math.abs(colValue) / 100 + 0.1).toFixed(2);

    let stop;

    if (index === 0) {
      stop = `0%`;
    } else if (index === columnValues.length - 1) {
      stop = `100%`;
    } else {
      stop = `${Math.round(100 * (index + 0.5) / columnValues.length)}%`;
    }
    return `rgba(${rgb.join(',')}, ${opacity}) ${stop}`;
  };

  const getColumnsBackgroundStyle = () => {
    const bgImageParts = columnValues.map(getBgImagePart);

    return {
      backgroundImage: `linear-gradient(to right, ${bgImageParts.join(', ')})`
    };
  };

  return (
    <div className="csw-r-spect-columns">

      <div className="csw-r-spect-columns-values" style={getColumnsBackgroundStyle()}>
        {columns && columns.map((column, index) => {
          const { text } = column;
          const answered = index === answeredIndex;
          const colTextId = stringReplace(text, ' ', '-');
          return (
            <div className={classNames('csw-r-spect-column', {
                  'csw-r-spect-column-answered': answered
                 })}
                 key={`csw-r-spect-o-column-${colTextId}-${index}`}>{text}</div>
          );
        })}
      </div>

    </div>
  );
};

SpectrumResultColumns.propTypes /* remove-proptypes */ = {
  columns: PropTypes.array.isRequired,
  columnValues: PropTypes.array.isRequired,
  answeredIndex: PropTypes.number
};

export default SpectrumResultColumns;
